import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function LineBanner({section, children}: CommonSectionProps) {
  const {ref, inView, entry} = useInView();

  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
        },
        viewimp_contents: {
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView]);

  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        click: {
          layer1: '라인',
          imp_id: 'sline',
          imp_provider: 'service',
        },
        viewimp_contents: {
          imp_id: 'sline',
          layer1: '라인',
        },
        customProps: {
          section_type: '라인',
        },
      })}
    >
      <div>{children}</div>
    </div>
  );
}
